// https://caniuse.com/mdn-api_response_json_static
if (!Response.json) Response.json = (data) => {
    const headers = new Headers();
    headers.set("Content-Type", "application/json; charset=utf-8");

    return new Response(JSON.stringify(data), { headers });
};
